import { SearchObject } from "app/common/Model/SearchObject";
import { reportPatientByAgeAndGender } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";

class ChartStatisticsStore {
  dataReportPatientByAgeAndGender = null;

  constructor() {
    makeAutoObservable(this);
  }

  reportPatientByAgeAndGender = async (obj) => {
    let { data } = await reportPatientByAgeAndGender(obj);
    this.dataReportPatientByAgeAndGender = data;
  }

  resetStore = () => {
    this.searchObject = new SearchObject();
    this.dataReportPatientByAgeAndGender = null;
  };
}

export default ChartStatisticsStore;
